export default function cipherTimestamp() {
  const ts = Date.now();
  const encoded = (ts * 867472) / 323 + 5234;
  return btoa(encoded);
}
